// Angular
import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
// Services
import { ApiService } from './../../services/api';
import { ElasticService } from './../../services/elastic';
// External
import * as lodash from 'lodash';
import { environment } from './../../../environments/environment'
import { AngularFireDatabase } from 'angularfire2/database';
import { HttpClient } from '@angular/common/http';
import { OAuthService } from 'app/services/o-auth';
import { Observable, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-user-select-modal-new',
  templateUrl: './user-select-modal-new.component.html',
  styleUrls: ['./user-select-modal-new.component.scss']
})
export class UserSelectModalNewComponent implements OnInit {

    @Input() tournamentId: string;
    @Input() isMultiRound = false;
    @Output() choosenPlayer: EventEmitter<any>;
    @Input() syncLocalTeamEvent: Observable<void>;
    public localTeamPlayers = [];
    public eventsSubscription: Subscription;
    public query: string;
    public users: Array<any>;
    public tournament;
    private typingDelay: any;
    public selectedUsers: Array<any>
    public alreadySelected = [];
    public notify;
    public openUserForm = false;
    public createdUser: any;
    public showLoader = false;

    constructor(private apiService: ApiService, private fireDatabase: AngularFireDatabase, private elasticService: ElasticService, private http: HttpClient, private oAuthService: OAuthService) {
        this.query = '';
        this.selectedUsers = [];
        this.choosenPlayer = new EventEmitter();
    }

    async ngOnInit() {
        let self = this
        $('#invite-users-new').on('hidden.bs.modal', function () {
            self.openUserForm = false;
        });
        if (this.syncLocalTeamEvent)
        {
            this.eventsSubscription = this.syncLocalTeamEvent.subscribe((data: any) => {
                this.localTeamPlayers = data.players;
            });
        }
        
        this.query = '';
        await this.getFilterList();
        this.searchMention(); 
    }

    async getFilterList() {

        if (!this.isMultiRound)
        {
            this.tournament = await this.apiService.object("tournaments/" + this.tournamentId);
           
            if ((this.tournament.type == 0 || this.tournament.type == 1) && (this.tournament.team == 1 || this.tournament.team == 2)) //team
            {
                console.log("team:  ");
                
                let fixtures = await this.apiService.object("tournament-fixtures/" + this.tournamentId);
                this.alreadySelected = this.localTeamPlayers;
                if (fixtures.$exists())
                {
                    lodash.forEach(fixtures, (fixture) => {
                            lodash.forEach(fixture.players, (value, player) => {
                                this.alreadySelected.push(player);
                            });
                        });
                }
                        
                    this.alreadySelected = Array.from(new Set(this.alreadySelected));
            }
            else { //individual or matchplay
                console.log("individual or matchplay:  ");
                this.alreadySelected = [];
                if(this.tournament.enteries)
                {
                    lodash.forEach(this.tournament.enteries, (item, key) => {
                        if (item) {
                            this.alreadySelected.push(key);
                        }
                    });
                    this.alreadySelected = Array.from(new Set(this.alreadySelected));
                }
                    
            }
        }
        else {

            this.tournament = await this.apiService.object("multi-round/" + this.tournamentId);
            this.alreadySelected = [];
            lodash.forEach(this.tournament.enteries, (item, key) => {
                if (item) {
                    this.alreadySelected.push(key);
                }
            });
            this.alreadySelected = Array.from(new Set(this.alreadySelected));
        }
    }

    displayHandicap(handicap) {
        return parseFloat(handicap).toFixed(1);
    }

    searchMention() {
        const queryParams = {
            'index': 'users',
            'type': 'user',
            'body/query/bool/must/query_string/query': `${this.query}*`,
            'body/query/bool/must/query_string/fields': ['fullName^10', 'username^2']
        };
        this.elasticService.search(queryParams)
            .then(result => {
                this.users = [];
                this.getFilterList();
                if (result&&result['hits']) {
                    lodash.forEach(result['hits'], item => {
                        const user = lodash.assign({ $key: item['_id'] }, item['_source']);
                        if (this.alreadySelected.findIndex(id => id == user.$key) == -1) {
                            user.isSelected = this.selectedUsers.findIndex(id => id == user.$key) != -1
                            this.users.push(user);
                        }
                    });
                }

            })
            .catch(error => {
                console.error(error);
            });
    }

    changeQuery() {
        clearTimeout(this.typingDelay);

        this.typingDelay = setTimeout(() => {
            this.searchMention();
        }, 400);
    }
    selectedUser: any;
    inviteUser(user) {

        this.selectedUser = user;
        this.selectedUser.handicap = parseFloat(this.selectedUser.handicap).toFixed(1);
        this.openUserForm = true;
        this.isOpenManualPlayerForm = false;
        if (!user.isSelected) {
            this.selectedUsers.push(user.$key)

            user.isSelected = true

        } else {
            user.isSelected = false

            let i = this.selectedUsers.findIndex(id => id == user.$key)
            this.selectedUsers.splice(i, 1)
        }
    }
    validateHandicapRequired()
    {
        
        let returnVal;


        let globalRegex=new RegExp("^([-]{0,1})([0-9]{1,2}|[1-9]{1,1}[0-9]{1,1})([.]{1}[0-9]{1})?$") ;
        this.selectedUser.handicap = "" + this.selectedUser.handicap;
        let regExTest = globalRegex.test(this.selectedUser.handicap)
        if ((regExTest && !isNaN(parseFloat(this.selectedUser.handicap)) && parseFloat(this.selectedUser.handicap) >= -10.9 && parseFloat(this.selectedUser.handicap) <= 54.9 && this.selectedUser.handicap.length <6)||(this.selectedUser.isPro))
        {
            returnVal = false;
        }
        else
        {
            returnVal =  true;
        }

        return returnVal;
    }

    validateEmail() {
        var re = new RegExp("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$");
        if (re.test(this.selectedUser.email)) {            
            return true;
        } else {
            return false;
        }
    }

    validateOnlyHandicap(event)
    {

    if(
        event.keyCode == 8 || //backspace
        event.keyCode == 37 || //left arrow
        event.keyCode == 39 || //right arrow
        event.keyCode == 46 || //delete
        event.keyCode == 189 || //-
        event.keyCode == 190 || //.
        event.keyCode == 109 || //- numLock
        event.keyCode == 110 || //. numLock
        (event.keyCode >= 48 && event.keyCode <= 57) ||
        (event.keyCode >= 96 && event.keyCode <= 105)
        ) {
        return true;
        }
        return false;
  }
    public async submit() {
        await this.getFilterList();
        if(this.alreadySelected.includes(this.selectedUser.$key))
        {
            alert(`This Player has been already added`);
            return;
        }
        this.selectedUser.handicap = parseFloat(this.selectedUser.handicap);
        this.selectedUser.id = this.selectedUser.$key;
        this.choosenPlayer.emit({ player: this.selectedUser });
        this.close();
    }
    
    public async close(){
        this.query=""
        this.changeQuery();
        this.openUserForm = false;
        this.isOpenManualPlayerForm = false;
        this.createdUser = undefined;
        await this.getFilterList();
    }


    // addPlayer
    isOpenManualPlayerForm = false;

    openManualPlayerForm()
    {
        this.isOpenManualPlayerForm = true;
        this.openUserForm = false;
        this.selectedUser = { fullName: "", isPro: false, handicap: "", email: ""};
    }

    checkUserName(username) {
        return  new Promise((resolve, reject) => {
            this.fireDatabase.database.ref('/index/users/').orderByValue().startAt(username).endAt(username).once("value",async (res) => {
                let result = res.val();
                resolve(result);
            });
        });
    }

    async addManualPlayer()
    {
        this.showLoader = true;
        this.selectedUser.handicap = parseFloat(this.selectedUser.handicap);
        this.selectedUser.firstName = this.selectedUser.fullName.split(' ')[0];
        this.selectedUser.username = this.selectedUser.email.replace(/[^a-zA-Z0-9]/g, '_');
        let flag = true;
        for (; flag;)
        {
            let data = await this.checkUserName(this.selectedUser.username);
            if (data)
            {
                this.selectedUser.username = this.selectedUser.username + "1";
            }
            else {
                //call api
                flag = false;
                this.selectedUser.isPasswordUpdate = true;
                this.selectedUser.isSystemPlayer = true;
                this.selectedUser.lastName = "";
                this.selectedUser.type = 2;

                this.selectedUser.createdAt = new Date().valueOf()/1000;
                this.selectedUser.lastLogin = this.selectedUser.createdAt;
                this.selectedUser.lastName = "";
                this.selectedUser.addedBy = this.oAuthService.getClub().fullName ? this.oAuthService.getClub().fullName : this.oAuthService.getClub().firstName;

                let body = this.selectedUser;
                this.http.post(environment.userCheckUrl, body).subscribe(async (result: any) => {
                    if (result.response.isSystemPlayer)
                    {
                        await this.getFilterList();
                        if (this.alreadySelected.includes(result.response.uid))
                        {
                            alert(`Player with ${this.selectedUser.email} has been added already , Please try again with different email !!!`);
                            this.onClickBack();
                        }
                        else {
                            let player = result.response
                            player.id = player.uid;
                            player.$key = player.uid;
                            player.name = player.fullName;
                            this.choosenPlayer.emit({ player: player});
                            this.close();
                        }
                        
                    }    
                    else {
                        //show dialogue to choose player yes or no
                        await this.getFilterList();
                        if (this.alreadySelected.includes(result.response.uid))
                        {
                            alert(`Player with ${this.selectedUser.email} has been added already , Please try again with different email !!!`);
                            this.onClickBack();
                        }
                        else {
                            this.createdUser = result.response;
                            this.createdUser.id = this.createdUser.uid;
                            this.createdUser.$key = this.createdUser.uid;
                        }
                        
                    }
                    this.showLoader = false;
                });
            }
        }
    }

    onClickAdd()
    {
        
        this.choosenPlayer.emit({ player: this.createdUser });
        this.close();
    }

    async onClickBack()
    {
        this.createdUser = undefined;
        this.isOpenManualPlayerForm = true;
        this.openUserForm = false;
        await this.getFilterList();
    }
}
